import { pmFetchJson } from "@penmate/react-shared/api/pmFetch";

export type PostcardTheme = {
  url?: string;
  source?: string;
  data?: { created_at?: string };
};

export async function fetchPostcardThemes(): Promise<readonly PostcardTheme[]> {
  const res = await pmFetchJson<unknown>("/postcards/themes", { method: "GET" });
  return Array.isArray(res) ? (res as PostcardTheme[]) : [];
}

